import React, { useContext } from 'react';
import axios from 'axios';
import { API_HOST } from '../../../consts';
import { toast } from 'react-toastify';
import { ThemeContext } from '../../../contexts/ThemeContext';

const ButtonsForm = ({
  isAvaliacaoForm = false,
  last,
  onClick,
  disabled,
}) => {
  const theme = useContext(ThemeContext);
  const handleExportToExams = () => {
    const id = window.location.pathname.split('/');
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${id[2]}/exame`)
      .then((response) => {
        toast.success('Aplicação enviada com sucesso.')
        this.toggleEnviarAvaliacaoModal(response.data.collection.id)
      })
      .catch(({ response }) => {
        if (response && response.status === 400) {
          this.openModalError()
          this.setState({ messageErro: response.data })
        } else if (response && response.status === 500) {
          toast.error('Ocorreu um erro ao gerar o JSON da avaliação.')
        }
      })
  };

  if (isAvaliacaoForm) {
    return (
      <>
        <button
          disabled={disabled}
          type="button"
          onClick={() => onClick(last)}
          className="sc-AxiKw coUCbo btn mb-3 ml-3"
          style={{
            borderRadius: "50px",
            backgroundColor: theme.primary,
            color: 'white',
            fontFamily: 'Public Sans',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0em',
            textAlign: 'center',
          }}
        >
          Salvar e finalizar
        </button>
        <button
          disabled={disabled}
          type="button"
          onClick={handleExportToExams}
          className="sc-AxiKw coUCbo btn mb-3 ml-3"
          style={{
            borderRadius: "50px",
            backgroundColor: theme.primary,
            color: 'white',
            fontFamily: 'Public Sans',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0em',
            textAlign: 'center',
          }}
        >
          Enviar para aplicação
        </button>
      </>
    )
  } else {
    return (
      <button
        disabled={disabled}
        type="button"
        onClick={() => onClick(last)}
        className="sc-AxiKw coUCbo btn mb-3 ml-3"
        style={{
          borderRadius: "50px",
          backgroundColor: theme.primary,
          color: 'white',
          fontFamily: 'Public Sans',
          fontSize: '16px',
          fontWeight: 700,
          lineHeight: '24px',
          letterSpacing: '0em',
          textAlign: 'center',
        }}
      >
        Finalizar
      </button>
    )
  }
}

export default ButtonsForm;